import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Home from "./pages/homepage";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import CarsPage from "./pages/Cars";
import SingleCar from "./pages/SingleCar";

import Login from "./auth/Login";
import AddCar from "./admin/AddCar";
import ManageCars from "./admin/MenageCars";

import AdminRoute from "./components/AdminRoute";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/contact" element={<Contact />} />

      <Route path="/cars" element={<CarsPage />} />
      <Route path="/cars/:id" element={<SingleCar />} />

      <Route path="/login" element={<Login />} />

      <Route
        path="/admin"
        element={
          <AdminRoute>
            <Navigate to="/admin/add-car" replace />
          </AdminRoute>
        }
      />

      <Route
        path="/admin/add-car"
        element={
          <AdminRoute>
            <AddCar />
          </AdminRoute>
        }
      />

      <Route
        path="/admin/manage-cars"
        element={
          <AdminRoute>
            <ManageCars />
          </AdminRoute>
        }
      />
    </Routes>
  );
}